import useIsMobile from '@/hooks/useIsMobile';
import useList from './useList';
import CustomerListDesktop from './desktop';
import CustomerListMobile from './mobile';

const CustomerListPage = () => {
  const isMobile = useIsMobile(768);
  const viewModel = useList();

  return isMobile ? (
    <CustomerListMobile viewModel={viewModel} />
  ) : (
    <CustomerListDesktop viewModel={viewModel} />
  );
};

export default CustomerListPage;
